import axios from 'axios';
import { store } from '../app/store';
import Cookies from 'js-cookie';

export default () => {
  const { auth } = store.getState();
  const BASE_URL = process.env.REACT_APP_API_URL;
  const instance = axios.create({
    headers: {
      Authorization: `Bearer ${auth.id_token}`,
      'Content-Type': 'application/json',
      Accept: '*/*'
    },
    baseURL: BASE_URL
  });
  instance.interceptors.request.use(
    function (config) {
      if (auth.id_token === '') {
        Cookies.remove('expires_in');
        Cookies.remove('currentVendor');
        window.location.href = `${window.location.origin}/login`;
      } else {
        return config;
      }
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response && typeof error.response.data !== 'object') {
        if (
          error.response.data.includes('bigger than 2') ||
          error.response.data.includes('could not parse token')
        ) {
          Cookies.remove('expires_in');
          Cookies.remove('currentVendor');
          window.location.href = `${window.location.origin}/login`;
        } else {
          return Promise.reject(error);
        }
      } else {
        return error;
      }
    }
  );
  return instance;
};
